<form [formGroup]="formUser" (ngSubmit)="onSubmitUser()">
  <div class="flex justify-center items-center">
    <div
      class="py-5 mt-10 w-full max-w-lg bg-white rounded-lg border border-100"
    >
      <div class="px-8 border-b border-100">
        <h1 class="mb-1 text-lg font-semibold text-text-900">Buscar cliente</h1>
        <p class="mb-4 text-gray-600">
          Busque o cliente para encontrar os dentistas mais próximos dele.
        </p>
      </div>

      <div class="flex gap-2 justify-center items-center px-8 mt-6">
        <app-input-icon
          formControlName="cpf"
          label="CPF"
          icon="search"
          position="left"
          placeholder="Digite o CPF..."
          class="flex-1 mb-6"
        />

        <app-button
          label="Buscar"
          buttonType="solid"
          buttonAction="default"
          type="submit"
          [disabled]="formUser.get('cpf')?.invalid"
        />
      </div>
    </div>
  </div>
</form>

@if (userSearchResult$ | async; as result) {
  @if (result.user) {
    <div class="flex justify-center items-center mt-4">
      <div class="p-8 w-full max-w-lg bg-white rounded-lg border border-100">
        <h2 class="text-lg font-semibold text-text-900">Cliente encontrado</h2>

        @if (result.user.hasAppointmentCandidate) {
          <app-alert
            message="Processo iniciado pelo beneficiário no app"
            class="mt-6"
          />
        }

        <div class="pb-3 mb-4 mt-6 border-b border-100">
          <p class="text-xs">Nome</p>
          <p class="mb-4 text-sm font-semibold">
            {{ formUser.get('name')?.value }}
          </p>

          <p class="text-xs">CPF</p>
          <p class="mb-4 text-sm font-semibold">
            {{ formUser.get('cpf')?.value | cpf }}
          </p>

          <p class="text-xs">Data de nascimento</p>
          <p class="mb-4 text-sm font-semibold">
            {{ formUser.get('birthDate')?.value | date: 'dd/MM/yyyy' }}
          </p>

          @if (!editMode) {
            <p class="text-xs">Telefone</p>
            <p class="mb-4 text-sm font-semibold">
              {{ formUser.get('phone')?.value | phone }}
            </p>

            <p class="text-xs">E-mail</p>
            <p class="mb-4 text-sm font-semibold">
              {{ formUser.get('email')?.value }}
            </p>
          } @else {
            <form [formGroup]="formUser" novalidate class="mb-2 w-3/4">
              <app-input-text
                formControlName="phone"
                label="Telefone"
                placeholder="Digite o telefone..."
                fullWidth
                class="mb-4"
              />

              <app-input-text
                formControlName="email"
                label="E-mail"
                placeholder="Digite o e-mail..."
                fullWidth
              />
            </form>
          }
        </div>

        <div class="flex justify-between items-center mb-4">
          <h3 class="text-base font-semibold">Endereços</h3>
        </div>

        <form [formGroup]="formAddress" novalidate>
          @for (opt of addressOptions; track opt.key; let i = $index) {
            <div class="flex justify-between items-center pb-2 mb-3">
              <div class="flex items-center">
                <p-radiobutton
                  [inputId]="'addrOpt_' + i"
                  name="selectedAddress"
                  formControlName="selectedAddress"
                  [value]="opt.originalData"
                  (onClick)="selectAddress(opt.originalData)"
                />
                <div class="flex flex-col">
                  <p class="ml-2 text-xs">
                    {{ opt.originalData.title }}
                  </p>

                  <label
                    [for]="'addrOpt_' + i"
                    class="ml-2 text-sm font-semibold cursor-pointer text-text-900"
                  >
                    {{ opt.name }}
                  </label>
                </div>
              </div>

              @if (editMode) {
                <div class="flex gap-2">
                  <app-action-icon-button
                    icon="edit"
                    type="edit"
                    (handleClick)="openAddressModal(opt.originalData)"
                  />
                  <app-action-icon-button
                    icon="delete"
                    type="delete"
                    (handleClick)="confirmDeleteAddress(opt.originalData)"
                  />
                </div>
              }
            </div>
          } @empty {
            <div
              class="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md"
            >
              <p class="text-sm text-yellow-800">
                <i class="material-symbols-outlined text-yellow-600 mr-2"
                  >warning</i
                >
                Para continuar, é necessário cadastrar um endereço. Por favor,
                adicione um clicando em 'Editar'.
              </p>
            </div>
          }

          @if (editMode) {
            <button
              type="button"
              (click)="addNewAddress()"
              class="flex items-center text-sm font-medium text-primary-500 hover:text-primary-600"
            >
              <i class="mr-1 text-sm material-symbols-outlined">add</i>
              Adicionar endereço
            </button>
          }
        </form>

        <div class="grid grid-cols-2 gap-2 mt-8">
          @if (!editMode) {
            <app-button
              label="Editar"
              buttonType="secondary"
              buttonAction="default"
              (handleClick)="handleEditMode()"
              fullSize
            />
            <app-button
              label="Avançar"
              buttonType="solid"
              buttonAction="default"
              (handleClick)="onGoNext()"
              [disabled]="addressOptions.length === 0"
              fullSize
            />
          } @else {
            <app-button
              label="Cancelar"
              buttonType="secondary"
              buttonAction="default"
              (handleClick)="handleEditMode()"
              fullSize
            />
            <app-button
              label="Salvar"
              buttonType="solid"
              buttonAction="default"
              (handleClick)="saveChanges()"
              fullSize
            />
          }
        </div>
      </div>
    </div>
  } @else if (!result.loading && !result.user) {
    <div
      class="flex justify-center items-center mt-4 font-semibold text-red-600"
    >
      Usuário não encontrado
    </div>
  }
}

<app-modal
  [visible]="addressModalVisible"
  (visibleChange)="addressModalVisible = $event"
  [title]="addressModalTitle"
  [width]="'550px'"
  [footerTemplate]="addressFooterTemplate"
  [closeOnEscape]="false"
  (close)="closeAddressModal()"
>
  <div class="p-4">
    <div class="mb-4">
      <h3 class="mb-2 text-base font-semibold">Endereços</h3>
      <div class="flex gap-2 mb-4">
        <div
          (click)="onAddressTypeChange(addressType.HOME)"
          (keydown.enter)="onAddressTypeChange(addressType.HOME)"
          tabindex="0"
          class="flex-1 p-4 rounded-md border transition-colors cursor-pointer"
          [ngClass]="{
            'bg-secondary-500 border-secondary-500': isHomeAddress(),
            'border-200': !isHomeAddress(),
          }"
        >
          <div class="flex justify-start items-center">
            <span
              class="material-symbols-outlined"
              [ngClass]="{
                'text-text-900': isHomeAddress(),
                'text-text-700': !isHomeAddress(),
              }"
              >home</span
            >
          </div>
          <p
            class="mt-3 text-sm font-medium"
            [ngClass]="{
              'text-text-900': isHomeAddress(),
              'text-text-700': !isHomeAddress(),
            }"
          >
            {{ addressTypeLabel[addressType.HOME] }}
          </p>
        </div>

        <div
          (click)="onAddressTypeChange(addressType.WORK)"
          (keydown.enter)="onAddressTypeChange(addressType.WORK)"
          tabindex="0"
          class="flex-1 p-4 rounded-md border transition-colors cursor-pointer"
          [ngClass]="{
            'bg-secondary-500 border-secondary-500': isWorkAddress(),
            'border-200': !isWorkAddress(),
          }"
        >
          <div class="flex justify-start items-center">
            <span
              class="material-symbols-outlined"
              [ngClass]="{
                'text-text-900': isWorkAddress(),
                'text-text-700': !isWorkAddress(),
              }"
              >work</span
            >
          </div>
          <p
            class="mt-3 text-sm font-medium"
            [ngClass]="{
              'text-text-900': isWorkAddress(),
              'text-text-700': !isWorkAddress(),
            }"
          >
            {{ addressTypeLabel[addressType.WORK] }}
          </p>
        </div>

        <div
          (click)="onAddressTypeChange(addressType.OTHER)"
          (keydown.enter)="onAddressTypeChange(addressType.OTHER)"
          tabindex="0"
          class="flex-1 p-4 rounded-md border transition-colors cursor-pointer"
          [ngClass]="{
            'bg-secondary-500 border-secondary-500': isOtherAddress(),
            'border-200': !isOtherAddress(),
          }"
        >
          <div class="flex justify-start items-center">
            <span
              class="material-symbols-outlined"
              [ngClass]="{
                'text-text-900': isOtherAddress(),
                'text-text-700': !isOtherAddress(),
              }"
              >location_on</span
            >
          </div>
          <p
            class="mt-3 text-sm font-medium"
            [ngClass]="{
              'text-text-900': isOtherAddress(),
              'text-text-700': !isOtherAddress(),
            }"
          >
            {{ addressTypeLabel[addressType.OTHER] }}
          </p>
        </div>
      </div>
    </div>

    @if (addressForm) {
      <form [formGroup]="addressForm" class="mt-4">
        @if (isOtherAddress()) {
          <div class="mb-3">
            <app-input-text
              formControlName="title"
              label="Título"
              placeholder="Como deseja chamar esse endereço?"
              fullWidth
            />
          </div>
        }

        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12 grid grid-cols-12 gap-4 items-end">
            <div class="col-span-10">
              <app-input-text
                formControlName="zipCode"
                label="CEP"
                placeholder="00000-000"
                type="tel"
                fullWidth
              />
            </div>
            <div class="col-span-2">
              <app-button
                label="Buscar"
                buttonType="solid"
                buttonAction="default"
                [disabled]="isCepLoading"
                (handleClick)="onSearchCep()"
                fullSize
              />
            </div>
          </div>

          <div class="col-span-2">
            <app-input-text
              formControlName="state"
              label="Estado"
              placeholder="UF"
              fullWidth
            />
          </div>

          <div class="col-span-10">
            <app-input-text
              formControlName="city"
              label="Cidade"
              placeholder="Recife"
              fullWidth
            />
          </div>

          <div class="col-span-4">
            <app-input-text
              formControlName="neighborhood"
              label="Bairro"
              placeholder="Bairro"
              fullWidth
            />
          </div>

          <div class="col-span-6">
            <app-input-text
              formControlName="street"
              label="Rua/Avenida"
              placeholder="Rua Otto"
              fullWidth
            />
          </div>

          <div class="col-span-2">
            <app-input-text
              formControlName="number"
              label="Número"
              placeholder="123456"
              fullWidth
            />
          </div>

          <div class="col-span-12">
            <app-input-text
              formControlName="complement"
              label="Complemento"
              placeholder="Apartamento, bloco, etc."
              fullWidth
            />
          </div>

          <div class="col-span-12">
            <app-input-text
              formControlName="reference"
              label="Referência"
              placeholder="Ponto de referência"
              fullWidth
            />
          </div>
        </div>
      </form>
    }
  </div>
</app-modal>

<ng-template #addressFooterTemplate>
  <div class="flex flex-col gap-2 items-center w-full">
    <div class="grid grid-cols-2 gap-2 w-full">
      <app-button
        label="Voltar"
        buttonType="secondary"
        buttonAction="default"
        (handleClick)="closeAddressModal()"
        fullSize
      />
      <app-button
        label="Salvar endereço"
        buttonType="solid"
        buttonAction="default"
        (handleClick)="saveAddress()"
        [disabled]="addressForm.invalid"
        fullSize
      />
    </div>

    @if (editingAddressId) {
      <app-button
        label="Excluir endereço"
        buttonType="secondary"
        buttonAction="negative"
        (handleClick)="confirmDeleteAddress()"
      />
    }
  </div>
</ng-template>

<app-modal
  [visible]="confirmModalVisible"
  (visibleChange)="confirmModalVisible = $event"
  [title]="'Confirmar exclusão'"
  [width]="'400px'"
  [footerTemplate]="confirmFooterTemplate"
  [closeOnEscape]="true"
  (close)="cancelDeleteAddress()"
>
  <p class="px-1 py-5">Tem certeza que deseja excluir este endereço?</p>
</app-modal>

<ng-template #confirmFooterTemplate>
  <div class="flex gap-2 justify-end">
    <app-button
      label="Cancelar"
      buttonType="secondary"
      buttonAction="default"
      (handleClick)="cancelDeleteAddress()"
    />
    <app-button
      label="Excluir"
      buttonType="solid"
      buttonAction="negative"
      (handleClick)="executeDeleteAddress()"
    />
  </div>
</ng-template>
